"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MICROSERVICE_API_KEY_CREDENTIALS = exports.DEFAULT_AVEDA_INFO = exports.getValuesByDelimiter = exports.DELIMITER = exports.FERPA_NO_DATA_RELEASE_INFO = exports.INPUT_PHONE_DEFAULT_OPTIONS = exports.getPartsByDelimiter = exports.isPdf = exports.formatCurrency = exports.getOptionLabelFormated = exports.convertImgToBase64 = exports.getFormatDateNow = void 0;
var moment_1 = __importDefault(require("moment"));
var DELIMITER = "<<@>>";
exports.DELIMITER = DELIMITER;
var getFormatDateNow = function () { return (0, moment_1.default)().format("MM/DD/YYYY"); };
exports.getFormatDateNow = getFormatDateNow;
var convertImgToBase64 = function (url) {
    return new Promise(function (resolve, reject) {
        var img = document.createElement("img");
        img.onload = function () {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            canvas.height = img.height;
            canvas.width = img.width;
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0);
            var dataURL = canvas.toDataURL();
            resolve(dataURL);
        };
        img.onerror = function (err) {
            reject(err);
        };
        img.setAttribute("crossOrigin", "anonymous");
        img.src = url;
    });
};
exports.convertImgToBase64 = convertImgToBase64;
var getPartsByDelimiter = function (value) {
    return value.split(DELIMITER);
};
exports.getPartsByDelimiter = getPartsByDelimiter;
var getOptionLabelFormated = function (option) {
    return option.code ? "".concat(option.name, " (").concat(option.code, ")") : option.name;
};
exports.getOptionLabelFormated = getOptionLabelFormated;
var formatCurrency = function (value, currency, options) {
    if (value === void 0) { value = 0; }
    if (currency === void 0) { currency = "USD"; }
    var formatter = new Intl.NumberFormat(undefined, __assign(__assign({}, options), { style: "currency", currency: currency }));
    return formatter.format(value).replace(/([.,])00$/g, "");
};
exports.formatCurrency = formatCurrency;
var FERPA_NO_DATA_RELEASE_INFO = {
    id: 9,
    name: "Do Not Release Any Data",
    code: "NO DATA RELEASE"
};
exports.FERPA_NO_DATA_RELEASE_INFO = FERPA_NO_DATA_RELEASE_INFO;
var INPUT_PHONE_DEFAULT_OPTIONS = {
    defaultCountries: {
        us: {
            code: "US",
            value: "+1"
        }
    },
    maxLength: {
        us: 12,
        other: 100
    },
    zipMaxLength: {
        us: 5,
        other: 100
    }
};
exports.INPUT_PHONE_DEFAULT_OPTIONS = INPUT_PHONE_DEFAULT_OPTIONS;
var isPdf = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var arrayBuffer, uint8Array, bytes_1, hex, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, new Promise(function (resolve) {
                        var reader = new FileReader();
                        reader.onload = function () { return resolve(reader.result); };
                        reader.readAsArrayBuffer(file);
                    })];
            case 1:
                arrayBuffer = _a.sent();
                uint8Array = new Uint8Array(arrayBuffer);
                bytes_1 = [];
                uint8Array.forEach(function (byte) { return bytes_1.push(byte.toString(16)); });
                hex = bytes_1.join("").toLowerCase();
                return [2, hex.startsWith("25504446")];
            case 2:
                error_1 = _a.sent();
                return [2, false];
            case 3: return [2];
        }
    });
}); };
exports.isPdf = isPdf;
var getValuesByDelimiter = function (posIndex, value) {
    if (posIndex < 0 || !value) {
        return "";
    }
    var parts = getPartsByDelimiter(value);
    if (parts.length <= 0) {
        return "";
    }
    if (posIndex >= parts.length) {
        return "";
    }
    return parts[posIndex];
};
exports.getValuesByDelimiter = getValuesByDelimiter;
var DEFAULT_AVEDA_INFO = {
    admissionsAdvisor: {
        roleId: 10,
        emails: [
            {
                email: "teststaffaveda1@yopmail.com"
            }
        ]
    },
    campus: {
        id: 2,
        name: "Aveda Institute Maine",
        code: "Aveda Institute Maine",
        programs: []
    },
    campuses: [
        {
            id: 2,
            name: "Aveda Institute Maine"
        }
    ]
};
exports.DEFAULT_AVEDA_INFO = DEFAULT_AVEDA_INFO;
var MICROSERVICE_API_KEY_CREDENTIALS = {
    userId: 3,
    profileId: 3
};
exports.MICROSERVICE_API_KEY_CREDENTIALS = MICROSERVICE_API_KEY_CREDENTIALS;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2Z1bmN0aW9ucy9oZWxwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxrREFBMkI7QUFFM0IsSUFBTSxTQUFTLEdBQUcsT0FBTyxDQUFBO0FBeUlyQiw4QkFBUztBQXhJYixJQUFNLGdCQUFnQixHQUFHLGNBQU0sT0FBQSxJQUFBLGdCQUFNLEdBQUUsQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLEVBQTdCLENBQTZCLENBQUE7QUFnSXhELDRDQUFnQjtBQS9IcEIsSUFBTSxrQkFBa0IsR0FBRyxVQUFDLEdBQUc7SUFDM0IsT0FBTyxJQUFJLE9BQU8sQ0FBQyxVQUFDLE9BQU8sRUFBRSxNQUFNO1FBQy9CLElBQU0sR0FBRyxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLENBQUE7UUFDekMsR0FBRyxDQUFDLE1BQU0sR0FBRztZQUNULElBQUksTUFBTSxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsUUFBUSxDQUFDLENBQUE7WUFDN0MsSUFBTSxHQUFHLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQTtZQUNuQyxNQUFNLENBQUMsTUFBTSxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUE7WUFDMUIsTUFBTSxDQUFDLEtBQUssR0FBRyxHQUFHLENBQUMsS0FBSyxDQUFBO1lBQ3hCLEdBQUcsYUFBSCxHQUFHLHVCQUFILEdBQUcsQ0FBRSxTQUFTLENBQUMsR0FBRyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQTtZQUN6QixJQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsU0FBUyxFQUFFLENBQUE7WUFDbEMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxDQUFBO1FBQ3BCLENBQUMsQ0FBQTtRQUNELEdBQUcsQ0FBQyxPQUFPLEdBQUcsVUFBQyxHQUFHO1lBQ2QsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBO1FBQ2YsQ0FBQyxDQUFBO1FBQ0QsR0FBRyxDQUFDLFlBQVksQ0FBQyxhQUFhLEVBQUUsV0FBVyxDQUFDLENBQUE7UUFDNUMsR0FBRyxDQUFDLEdBQUcsR0FBRyxHQUFHLENBQUE7SUFDakIsQ0FBQyxDQUFDLENBQUE7QUFDTixDQUFDLENBQUE7QUE4R0csZ0RBQWtCO0FBNUd0QixJQUFNLG1CQUFtQixHQUFHLFVBQUMsS0FBSztJQUM5QixPQUFPLEtBQUssQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLENBQUE7QUFDakMsQ0FBQyxDQUFBO0FBOEdHLGtEQUFtQjtBQTVHdkIsSUFBTSxzQkFBc0IsR0FBRyxVQUFDLE1BQU07SUFDbEMsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxVQUFHLE1BQU0sQ0FBQyxJQUFJLGVBQUssTUFBTSxDQUFDLElBQUksTUFBRyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFBO0FBQ3hFLENBQUMsQ0FBQTtBQXVHRyx3REFBc0I7QUFyRzFCLElBQU0sY0FBYyxHQUFHLFVBQ25CLEtBQVMsRUFDVCxRQUFnQixFQUNoQixPQUFrQztJQUZsQyxzQkFBQSxFQUFBLFNBQVM7SUFDVCx5QkFBQSxFQUFBLGdCQUFnQjtJQUdoQixJQUFNLFNBQVMsR0FBRyxJQUFJLElBQUksQ0FBQyxZQUFZLENBQUMsU0FBUyx3QkFDMUMsT0FBTyxLQUNWLEtBQUssRUFBRSxVQUFVLEVBQ2pCLFFBQVEsVUFBQSxJQUtWLENBQUE7SUFFRixPQUFPLFNBQVMsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsT0FBTyxDQUFDLFlBQVksRUFBRSxFQUFFLENBQUMsQ0FBQTtBQUM1RCxDQUFDLENBQUE7QUFzRkcsd0NBQWM7QUFwRmxCLElBQU0sMEJBQTBCLEdBQUc7SUFDL0IsRUFBRSxFQUFFLENBQUM7SUFDTCxJQUFJLEVBQUUseUJBQXlCO0lBQy9CLElBQUksRUFBRSxpQkFBaUI7Q0FDMUIsQ0FBQTtBQW9GRyxnRUFBMEI7QUFsRjlCLElBQU0sMkJBQTJCLEdBQUc7SUFDaEMsZ0JBQWdCLEVBQUU7UUFDZCxFQUFFLEVBQUU7WUFDQSxJQUFJLEVBQUUsSUFBSTtZQUNWLEtBQUssRUFBRSxJQUFJO1NBQ2Q7S0FDSjtJQUNELFNBQVMsRUFBRTtRQUNQLEVBQUUsRUFBRSxFQUFFO1FBQ04sS0FBSyxFQUFFLEdBQUc7S0FDYjtJQUNELFlBQVksRUFBRTtRQUNWLEVBQUUsRUFBRSxDQUFDO1FBQ0wsS0FBSyxFQUFFLEdBQUc7S0FDYjtDQUNKLENBQUE7QUFrRUcsa0VBQTJCO0FBakUvQixJQUFNLEtBQUssR0FBRyxVQUFPLElBQUk7Ozs7OztnQkFFUSxXQUFNLElBQUksT0FBTyxDQUFDLFVBQUMsT0FBTzt3QkFDL0MsSUFBTSxNQUFNLEdBQUcsSUFBSSxVQUFVLEVBQUUsQ0FBQTt3QkFDL0IsTUFBTSxDQUFDLE1BQU0sR0FBRyxjQUFNLE9BQUEsT0FBTyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsRUFBdEIsQ0FBc0IsQ0FBQTt3QkFDNUMsTUFBTSxDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxDQUFBO29CQUNsQyxDQUFDLENBQUMsRUFBQTs7Z0JBSkksV0FBVyxHQUFRLFNBSXZCO2dCQUNJLFVBQVUsR0FBRyxJQUFJLFVBQVUsQ0FBQyxXQUFXLENBQUMsQ0FBQTtnQkFDeEMsVUFBUSxFQUFFLENBQUE7Z0JBQ2hCLFVBQVUsQ0FBQyxPQUFPLENBQUMsVUFBQyxJQUFJLElBQUssT0FBQSxPQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUMsRUFBN0IsQ0FBNkIsQ0FBQyxDQUFBO2dCQUNyRCxHQUFHLEdBQUcsT0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxXQUFXLEVBQUUsQ0FBQTtnQkFDeEMsV0FBTyxHQUFHLENBQUMsVUFBVSxDQUFDLFVBQVUsQ0FBQyxFQUFBOzs7Z0JBRWpDLFdBQU8sS0FBSyxFQUFBOzs7O0tBRW5CLENBQUE7QUFnREcsc0JBQUs7QUEvQ1QsSUFBTSxvQkFBb0IsR0FBRyxVQUFDLFFBQWdCLEVBQUUsS0FBYTtJQUN6RCxJQUFJLFFBQVEsR0FBRyxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUU7UUFDeEIsT0FBTyxFQUFFLENBQUE7S0FDWjtJQUNELElBQU0sS0FBSyxHQUFHLG1CQUFtQixDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQ3hDLElBQUksS0FBSyxDQUFDLE1BQU0sSUFBSSxDQUFDLEVBQUU7UUFDbkIsT0FBTyxFQUFFLENBQUE7S0FDWjtJQUNELElBQUksUUFBUSxJQUFJLEtBQUssQ0FBQyxNQUFNLEVBQUU7UUFDMUIsT0FBTyxFQUFFLENBQUE7S0FDWjtJQUNELE9BQU8sS0FBSyxDQUFDLFFBQVEsQ0FBQyxDQUFBO0FBQzFCLENBQUMsQ0FBQTtBQXdDRyxvREFBb0I7QUF0Q3hCLElBQU0sa0JBQWtCLEdBQUc7SUFDdkIsaUJBQWlCLEVBQUU7UUFDZixNQUFNLEVBQUUsRUFBRTtRQUNWLE1BQU0sRUFBRTtZQUNKO2dCQUNJLEtBQUssRUFBRSw2QkFBNkI7YUFDdkM7U0FDSjtLQUNKO0lBQ0QsTUFBTSxFQUFFO1FBQ0osRUFBRSxFQUFFLENBQUM7UUFDTCxJQUFJLEVBQUUsdUJBQXVCO1FBQzdCLElBQUksRUFBRSx1QkFBdUI7UUFDN0IsUUFBUSxFQUFFLEVBQUU7S0FDZjtJQUNELFFBQVEsRUFBRTtRQUNOO1lBQ0ksRUFBRSxFQUFFLENBQUM7WUFDTCxJQUFJLEVBQUUsdUJBQXVCO1NBQ2hDO0tBQ0o7Q0FDSixDQUFBO0FBa0JHLGdEQUFrQjtBQWhCdEIsSUFBTSxnQ0FBZ0MsR0FBRztJQUNyQyxNQUFNLEVBQUUsQ0FBQztJQUNULFNBQVMsRUFBRSxDQUFDO0NBQ2YsQ0FBQTtBQWNHLDRFQUFnQyJ9